import React from "react";
import {
  HeaderContainer,
  HeaderLeftContainer,
  TypographyContainer,
  HeaderRightContainer,
} from "./Header.styled";
import { Typography, Button } from "@ann/web-components";

const Header = ({ onCreateClick }) => {
  const handleButtonClick = () => {
    onCreateClick?.();
  };

  return (
    <HeaderContainer>
      <HeaderLeftContainer>
        <TypographyContainer>
          <Typography category="title" size="large" weight="bold">
            Workspace Management
          </Typography>

          <Typography category="body" size="medium" weight="regular" color="body">
            Centralize workspace control to boost efficiency and keep teams aligned.
          </Typography>
        </TypographyContainer>
      </HeaderLeftContainer>

      <HeaderRightContainer>
        <Button
          iconRight="plus"
          label="Create Workspace"
          size="medium"
          onClick={handleButtonClick}
          type="gradient"
        />
      </HeaderRightContainer>
    </HeaderContainer>
  );
};

export default Header;

